module.exports = __webpack_public_path__ + "img/pexels-mika-borgia-1317712.7c329197.jpg";